import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Text search input with a leading icon and a clear button that emits value changes as the user types.
 */
@Component({
  selector: 'es-search-bar',
  template: `
    <div class="relative">
      <span class="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-secondary)]">⌕</span>
      <input
        type="search"
        [placeholder]="placeholder"
        [value]="value"
        class="w-full pl-9 pr-8 py-2 text-sm rounded-lg bg-[var(--bg-secondary)] text-[var(--text)] border border-[var(--border)] placeholder:text-[var(--text-secondary)] focus:outline-none focus:border-echo-blue focus:ring-1 focus:ring-echo-blue/30 transition-colors font-exo"
        (input)="onInput($event)"
      />
      @if (value) {
        <button
          class="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--text-secondary)] hover:text-[var(--text)] cursor-pointer"
          (click)="clear()"
        >✕</button>
      }
    </div>
  `,
})
export class SearchBarComponent {
  @Input() placeholder = 'Suchen…';
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();
  @Output() cleared = new EventEmitter<void>();

  onInput(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    this.value = val;
    this.valueChange.emit(val);
  }

  clear() {
    this.value = '';
    this.valueChange.emit('');
    this.cleared.emit();
  }
}
